import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../AppContext";

const TrendingV5 = () => {
  const { users,sendClickStatus } = useContext(AppContext);
  const categories = ["न्यूज़", "मनोरंजन", "धर्म", "बिजनेस", "हेल्थ"];
  const [activeCategory, setActiveCategory] = useState("न्यूज़");
  const truncate = (str, n) => (str.length > n ? str.slice(0, n) + "..." : str);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  const filteredPosts = users
    .filter(
      (user) =>
        (user.post_type === "post" && user.category_name === activeCategory) ||
        (user.post_type === "New" && user.cat === activeCategory)
    )
    .filter((post) => {
      if (post.post_type === "post") {
        return users.some(
          (img) => img.post_type === "attachment" && img.post_parent === post.ID
        );
      } else {
        return true;
      }
    })
    .map((post) => {
      let imageUrl = "";

      if (post.post_type === "post") {
        const image = users.find(
          (img) => img.post_type === "attachment" && img.post_parent === post.ID
        );
        imageUrl = image ? image.guid : "";
      } else if (post.post_type === "New") {
        imageUrl = "https://hondaapi.clientcoding.com/" + post.guid;
      }

      return {
        id: post.ID,
        title: post.post_title,
        image: imageUrl,
        author: post.post_type === "New" ? post.author : post.author_name,
        category: post.post_type === "New" ? post.cat : post.category_name,
        post_date_gmt: post.post_date_gmt,
      };
    });

  let publicUrl = process.env.PUBLIC_URL + "/";

  return (
    <div className="tranding-area pd-top-75 pd-bottom-50 go-top">
      <div className="container">
        <div className="section-title style-two">
          <div className="row">
            <div className="col-md-3">
              <h6 className="title black">Trending News</h6>
            </div>
            <div className="col-md-9 text-center text-md-right">
              <div className="nxp-tab-inner nxp-tab-post text-md-right text-center">
                <ul className="nav nav-tabs">
                  {categories.map((category) => (
                    <li className="nav-item" key={category}>
                      <button
                        style={{ background: "transparent", border: "none" }}
                        className={`nav-link ${
                          activeCategory === category ? "active" : ""
                        }`}
                        onClick={() => setActiveCategory(category)}
                      >
                        {category}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="tab-content">
          <div className="tab-pane fade show active">
            <div className="row">
              {filteredPosts.length > 0 ? (
                filteredPosts.slice(0, 4).map((post) => (
                  <div className="col-lg-3 col-sm-6" key={post.id}>
                    <div className="single-post-wrap style-overlay">
                      <div className="thumb">
                        <img
                          src={post.image}
                          alt={post.title}
                          style={{
                            maxWidth: "100%",
                            objectFit: "cover",
                            height: "480px",
                          }}
                        />
                        <Link
                          className="tag-base tag-purple"
                          to={`/category/${post.category}`}
                           onClick={() => {
                                      sendClickStatus(post.id, "click");
                                    }}
                        >
                          {post.category}
                        </Link>
                      </div>
                      <div className="details">
                        <div className="post-meta-single">
                          <ul>
                            <li className="black">
                              <i className="fa fa-clock-o" />{" "}
                              {formatDate(post.post_date_gmt)}
                            </li>
                            <li>
                              <i className="fa fa-user" /> {post.author}
                            </li>
                          </ul>
                        </div>
                        <h6 className="title black">
                          <Link to={`/news-details/${post.id}`}  onClick={() => {
                                      sendClickStatus(post.id, "click");
                                    }}>
                            {truncate(post.title, 50)}
                          </Link>
                        </h6>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12 text-center py-5">
                  <p>No posts found in "{activeCategory}"</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendingV5;
